<template>
  <div :class="['main-navbar', 'bg-white', stickyTop ? 'sticky-top' : '']">
    <d-navbar class="align-items-stretch flex-md-nowrap p-0">
      <navbar-search />
      <navbar-nav />
    </d-navbar>
  </div>
</template>

<script>
import NavbarSearch from "./NavbarSearch.vue";
import NavbarNav from "./NavbarNav.vue";
import NavbarToggle from "./NavbarToggle.vue";

export default {
  components: {
    NavbarSearch,
    NavbarNav,
    NavbarToggle
  },
  props: {
    /**
     * Whether the main navbar should be sticky, or not.
     */
    stickyTop: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss">
.bg-white {
  background-color: white !important;
}
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}
</style>
